import { Typography, SxProps, Theme } from '@mui/material';

type InternshipLineItemProps = Readonly<{
  title: string;
  value: string;
}>;

export const InternshipLineItem = ({ title, value }: InternshipLineItemProps) => {
  return (
    <Typography variant="body1">
      <Typography component="span" variant="body1" sx={lineTitle}>
        {title}{' '}
      </Typography>
      {value}
    </Typography>
  );
};

const lineTitle: SxProps<Theme> = {
  fontWeight: 600,
  fontStyle: 'italic',
};
